@if (isCustomerView()) {
    <app-welcome-banner></app-welcome-banner>
    <app-customer-dashboard></app-customer-dashboard>
} @else {
    <app-ewa-staff-dashboard></app-ewa-staff-dashboard>
}
